import React from "react";

import { Button, Typography } from "@material-ui/core";

import SvgI24Archive from "assets/icons/I24Archive";
import SvgI24Edit from "assets/icons/I24Edit";

import TrimmedText from "components/TrimmedText";

import {
  Container,
  ImageContainer,
  Image,
  DetailsContainer,
  TextContainer,
  ControlsContainer,
  ControlWrapper,
} from "./styles";

type Props = {
  title: string;
  image: string;
  onEdit: () => void;
  onArchive: () => void;
};

class EquipmentCard extends React.Component<Props> {
  render() {
    const { title, image, onEdit, onArchive } = this.props;

    return (
      <Container>
        <ImageContainer>
          <Image image={image} />
        </ImageContainer>
        <DetailsContainer>
          <TextContainer>
            <TrimmedText lines={1} text={title}>
              <Typography variant="h3" color="textPrimary">
                {title}
              </Typography>
            </TrimmedText>
          </TextContainer>
        </DetailsContainer>
        <ControlsContainer>
          <ControlWrapper>
            <Button
              startIcon={<SvgI24Edit />}
              variant="text"
              color="secondary"
              onClick={onEdit}
            >
              Edit
            </Button>
          </ControlWrapper>
          <ControlWrapper>
            <Button
              startIcon={<SvgI24Archive />}
              variant="text"
              color="secondary"
              onClick={onArchive}
            >
              Archive
            </Button>
          </ControlWrapper>
        </ControlsContainer>
      </Container>
    );
  }
}

export default EquipmentCard;
